import { pluralized } from "common/utils/strings";

import { DosageReminder } from "../types";
import { INTERVAL_LABEL_DISPLAY } from "../constants";

export const getFrequencyLabel = ({ frequency, interval_unit: intervalUnit }: DosageReminder) => {
  if (frequency === 1) {
    return INTERVAL_LABEL_DISPLAY[intervalUnit];
  }
  return `Every ${frequency} ${pluralized(frequency, intervalUnit.toLowerCase())}`;
};
